// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {Proxy_type} from '../../../hola/pub/ui/pro/cp/orders';

export function assert_proxy_type(v: any): asserts v is Proxy_type{
    if (!Object.values(Proxy_type).includes(v))
        throw new Error(`Invalid product type: ${v}`);
}
